import React, { useMemo } from 'react';
import blogo from '../assets/onespa-logo.png';
import blogoOne from '../assets/onespa-logo.png';
import { Flex, Image, Layout, Menu } from 'antd';
import { IoBarChart, IoBarChartOutline, IoMegaphone, IoMegaphoneOutline } from "react-icons/io5";
import { HiOutlineUsers, HiUsers } from "react-icons/hi2";
import { BsBalloonHeart, BsBalloonHeartFill, BsQuestionCircle, BsQuestionCircleFill } from "react-icons/bs";
import { RiRefreshLine, RiRefreshFill } from "react-icons/ri";
const { Sider } = Layout;

const siderStyle = {
  overflow: 'auto',
  position: 'fixed',
  height: '100vh',
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: 'thin',
  scrollbarColor: 'unset',
};

const sideBarItems = (selectedKey) => {
  const allItems = [
    {
      key: 'home',
      icon: (
        <div className={`icon-wrapper ${selectedKey === 'home' ? 'active' : ''}`}>
          {selectedKey === 'home' ? <IoBarChart size={18} /> : <IoBarChartOutline size={18} />}
        </div>
      ),
      label: 'Dashboard',
    },
    {
      key: 'trial-customers',
      icon: (
        <div className={`icon-wrapper ${selectedKey === 'trial-customers' ? 'active' : ''}`}>
          {selectedKey === 'trial-customers' ? <IoMegaphone size={18} /> : <IoMegaphoneOutline size={18} />}
        </div>
      ),
      label: 'Trial Customers',
    },
    {
      key: 'paid-customers',
      icon: (
        <div className={`icon-wrapper ${selectedKey === 'paid-customers' ? 'active' : ''}`}>
          {selectedKey === 'paid-customers' ? <HiUsers size={18} /> : <HiOutlineUsers size={18} />}
        </div>
      ),
      label: 'Paid Customers',
    },
    {
      key: 'templates',
      icon: (
        <div className={`icon-wrapper ${selectedKey === 'templates' ? 'active' : ''}`}>
          {selectedKey === 'templates' ? <BsBalloonHeartFill size={18} /> : <BsBalloonHeart size={18} />}
        </div>
      ),
      label: 'Templates',
    },
    {
      key: 'help',
      icon: (
        <div className={`icon-wrapper ${selectedKey === 'help' ? 'active' : ''}`}>
          {selectedKey === 'help' ? <BsQuestionCircleFill size={18} /> : <BsQuestionCircle size={18} />}
        </div>
      ),
      label: 'Help',
    },
    {
      key: 'recent-transactions',
      icon: (
        <div className={`icon-wrapper ${selectedKey === 'recent-transactions' ? 'active' : ''}`}>
          {selectedKey === 'recent-transactions' ? <RiRefreshFill size={18} /> : <RiRefreshLine size={18} />}
        </div>
      ),
      label: 'Recent Transactions',
    },
  ];

  const restrictedKeys = ['channel-settings', 'account', 'stores', 'invite-team', 'channels', 'plans'];

  if (restrictedKeys.includes(selectedKey)) {
    return allItems.filter(item => item.key === 'home' || restrictedKeys.includes(item.key));
  }

  return allItems.filter(item => item.key === 'home' || !restrictedKeys.includes(item.key));
};

const SideBar = ({ collapsed, selectedKey, handleMenuClick }) => {
  const memoizedMenuItems = useMemo(() => sideBarItems(selectedKey === 'channel-settings' ? 'channels' : selectedKey), [selectedKey]);
  return (
    <Sider style={siderStyle} trigger={null} collapsible collapsed={collapsed} theme="light">
      <div className='mainLogo'>
        {collapsed ? (
          <Image src={blogoOne} preview={false} style={{ width: '100%' }} />
        ) : (
          <Flex style={{ display: 'flex', gap: '10px' }}>
            <Image src={blogo} preview={false} style={{ width: '100%', height: 40 }} />
            <p style={{ fontWeight: 700, fontSize: '20px', lineHeight: 0 }}>OneSpaAI</p>
          </Flex>
        )}
      </div>
      <Menu theme="light" mode="inline" className='sideBarMenu' selectedKeys={[selectedKey === 'channel-settings' ? 'channels' : selectedKey]} onClick={handleMenuClick} items={memoizedMenuItems} />
    </Sider>
  );

};

export default SideBar;